import PageFace from '../../Components/Page-Face/face';
import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';
import Footer from '../../Components/Footer/Footer';

function Face() {
  return (
    <>
      <div id="Mamas">
        <PageFace />
      </div>
      <div id="Agendamento">
        <Agendamento />
      </div>
      <div id="Footer">
        <Footer />
      </div>
    </>
  );
}

export default Face;